// The gallery construct holds all the items (pictures) represented in the Gallery component.
// There is one position for each of the docType subjects. Filled in the order they are captured.

import { createSlice } from "@reduxjs/toolkit";

export const gallerySlice = createSlice({
  name: "gallery",
  initialState: {
    value: {
      pictures: Array(4).fill({
        docType: "",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==",
        mibiData: {},
        decodedStr: "",
        documentCaptured: "",
        modeUsed: "",
      }),
      /**
       * test foreign driver's license data
       */
      // pictures: [
      //   {
      //     docType: "DL_FRONT",
      //     image:
      //       "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==",
      //     mibiData: {},
      //     decodedStr: "",
      //     documentCaptured: "driver's license front",
      //     modeUsed: "AUTO_CAPTURE",
      //     label: "Front",
      //   },
      //   {
      //     docType: "DL_FRONT",
      //     image:
      //       "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==",
      //     mibiData: {},
      //     decodedStr: "",
      //     documentCaptured: "driver's license back",
      //     modeUsed: "AUTO_CAPTURE",
      //     label: "Back",
      //   },
      // ],
    },
  },
  reducers: {
    // update existing picture of the same document type or add a new entry
    addOrUpdate: (state, action) => {
      const existingPicture = state.value.pictures.find(
        (p) => p.documentCaptured === action.payload.documentCaptured,
      );
      if (existingPicture) {
        existingPicture.docType = action.payload.docType;
        existingPicture.image = action.payload.image;
        existingPicture.mibiData = action.payload.mibiData;
        existingPicture.decodedStr = action.payload.decodedStr;
        existingPicture.documentCaptured = action.payload.documentCaptured;
        existingPicture.label = action.payload.label;
        existingPicture.modeUsed = action.payload.modeUsed;
      } else {
        const emptyPicture = state.value.pictures.find((p) => p.docType === "");
        emptyPicture.docType = action.payload.docType;
        emptyPicture.image = action.payload.image;
        emptyPicture.mibiData = action.payload.mibiData;
        emptyPicture.decodedStr = action.payload.decodedStr;
        emptyPicture.documentCaptured = action.payload.documentCaptured;
        emptyPicture.label = action.payload.label;
        emptyPicture.modeUsed = action.payload.modeUsed;
      }
    },
    clearPictures: (state, action) => {
      /**
       * Find pictures matching docType and clear out data
       * If no payload then clear all pictures
       */
      const matchingPictures = state.value.pictures.filter(
        (p) => p.docType === action.payload,
      );
      for (let picture of matchingPictures) {
        picture.docType = "";
        picture.image = "";
        picture.mibiData = {};
        picture.decodeStr = "";
        picture.documentCaptured = "";
        picture.modeUsed = "";
        picture.label = "";
      }
    },
  },
});

export const { addOrUpdate, clearPictures } = gallerySlice.actions;

export default gallerySlice.reducer;
